// External Dependencies
import { useMemo } from 'react';
import { InvoicesIndexResponse } from '@presto-assistant/api_types/api/admin/invoices';
import { GridColDef } from '@mui/x-data-grid-pro';

// Internal Dependencies
import { dateColumn, dateTimeColumn, currencyFromCentsColumn } from 'utils/lib/tableColumns';

export const useColumns = () => {
  return useMemo(() => {
    const columns: GridColDef<InvoicesIndexResponse['data'][number]>[] = [
      dateTimeColumn({
        field: 'createdAt',
        headerName: 'Created At',
        sortable: true,
      }),
      dateColumn({
        field: 'invoiceDate',
        headerName: 'Invoice Date',
        sortable: true,
      }),
      {
        field: 'status',
        headerName: 'Status',
        type: 'singleSelect',
        valueOptions: [
          {
            label: 'Unpaid',
            value: 'Unpaid',
          },
          {
            label: 'Paid',
            value: 'Paid',
          },
        ],
      },
      {
        field: 'districtName',
        headerName: 'Admin Portal',
      },
      {
        field: 'invoiceNumber',
        headerName: 'Invoice Number',
        type: 'number',
        valueFormatter: (params) => {
          return params.value;
        },
        width: 160,
      },
      currencyFromCentsColumn({
        field: 'totalInCents',
        headerName: 'Total',
        sortable: true,
      }),
    ] as GridColDef<InvoicesIndexResponse['data'][number]>[];

    return columns;
  }, []);
};
